export default __webpack_public_path__ + "static/media/deleteNote.9533b3c7.svg";